export default "/staticreactui/static/media/static/media/customer2.0642af84.webp";